<template>
    <md-dialog :md-active.sync="show" :mdClickOutsideToClose="false" :mdCloseOnEsc="false">
        <md-dialog-title>{{title}}</md-dialog-title>
        <md-dialog-content>

            <md-list class="md-dense" v-if="!isLoading">
                <md-list-item
                        v-for="(user, index) in contacts"
                        :key="index"
                        @click="toggleSelection(user)"
                        :disabled="selected(user.id)">
                    <md-avatar :class="`avatar-color-${user.type}`">
                        {{user.initial}}
                    </md-avatar>
                    <span class="md-list-item-text">{{user.email}}</span>
                </md-list-item>
            </md-list>

            <div v-else>
                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                Cargando lista de contactos
            </div>

            <div v-if="!isLoading && contacts.length === 0">
                Sin contactos.
            </div>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button @click="$emit('update:show', false)">Cerrar</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    export default {
        name: "DialogPersonSelection",
        props: {
            title: {
                type: String,
                required: true
            },
            project_id: {
                type: [Number, String]
            },
            show: {
                type: false,
                required: true
            },
            value: {
                type: Array,
                required: true,
                default: function () {
                    return [];
                }
            }
        },
        watch: {
            show (val) {
                if (val === true) {
                    this.getContact()
                }
            }
        },
        data: () => ({
            isLoading: false,
            contacts: []
        }),
        methods: {
            hello() {
                alert()
            },
            async getContact() {
                try {
                    this.isLoading = true;
                    const {data} = await axios.get(`/api/project/${this.project_id}/email_related`);
                    this.contacts = data;
                } catch(e) {
                    console.error(e);
                } finally {
                    this.isLoading = false;
                }
            },
            toggleSelection(email) {
                if(!this.selected(email.id)) {
                    this.value.push(email);
                } else {
                    this.deleteSender(email.id)
                }
            },
            selected(id) {
                let is_selected = false;
                this.value.map((user) => {
                    if (user.id === id)
                        is_selected = true;
                });

                return is_selected;
            },
            getIndexById(id) {
                let index = 0;
                this.value.map((user, i) => {
                    if (user.id === id)
                        index = i;
                });

                return index;
            },
            deleteSender(id) {
                this.value.splice(this.getIndexById(id), 1)
            },
        }
    }
</script>

<style scoped>

</style>